import Component from '../abstracts/Component';

export default class CollapseComponent extends Component {

  get COMPONENTNAME() {
    return 'CollapseComponent';
  }

  get SELECTORS() {
    return {
      trigger: '[data-trigger]',
      tab: '[data-tab]',
    };
  }

  get CLASSES() {
    return {
      collapsed: 'collapsed'
    }
  }

  constructor(compEl) {
    super(compEl);
  }

  readDOM() {
    return {
      triggers: this.$component.querySelectorAll(this.SELECTORS.trigger),
      tabs: this.$component.querySelectorAll(this.SELECTORS.tab),
      currentOpenTab: null,
    };
  }

  //get all the tabs and set the height
  init() {
    if(this.dom.tabs) {
      this.dom.tabs.forEach(tab => {
        tab.style.height = tab.offsetHeight + "px";
      });
    }
    if(this.dom.triggers) {
      this.dom.triggers.forEach(trigger => {
        if(trigger.dataset.trigger === "start-open") {
          this.dom.currentOpenTab = trigger;
        } else {
          trigger.classList.add(this.CLASSES.collapsed);
        }
      });
    }
  }

  //handle click on trigger element
  handleCollapse() {
    if(this.dom.triggers) {
      this.dom.triggers.forEach(trigger => {
        trigger.addEventListener("click", () => {
          const triggerToggle = trigger.querySelector("[aria-expanded]");
          if(this.dom.currentOpenTab === trigger) {
            // click on the same trigger to close the section
            trigger.classList.add(this.CLASSES.collapsed);
            trigger.dataset.trigger = "off";
            this.dom.currentOpenTab = null;
            triggerToggle.setAttribute("aria-expanded", "false");
          } else if(this.dom.currentOpenTab != null) {
            //another tab is currently open
            this.dom.currentOpenTab.classList.add(this.CLASSES.collapsed);
            this.dom.currentOpenTab.dataset.trigger = "off";
            this.dom.currentOpenTab.querySelector("[aria-expanded]").setAttribute("aria-expanded", "false");
            trigger.classList.remove(this.CLASSES.collapsed);
            trigger.dataset.trigger = "on";
            this.dom.currentOpenTab = trigger;
            triggerToggle.setAttribute("aria-expanded", "true");
          } else {
            //is the first trigger clicked
            trigger.classList.remove(this.CLASSES.collapsed);
            trigger.dataset.trigger = "on";
            this.dom.currentOpenTab = trigger;
            triggerToggle.setAttribute("aria-expanded", "true");
          }
        });
      });
    }
  }

  bindEvents() {
    this.handleCollapse();
  }

  render() {
    super.render();
    this.log('Rendering...');
    this.dom = this.readDOM();
    this.init();
    this.bindEvents();
  }
}
